<template>
  <div id="app">
    <div v-if="loading">Loading... </div>
    <div v-if="!result">{{ result_msg }}</div>
    <div v-if="loadError">数据加载失败, 请稍候再试</div>
    <div v-if="result" id="home">
        <hello 
             :heads="heads"> 
        </hello>
        <calc 
            v-for="calc in calcs" 
            :name="calc.name"
            :value="calc.value"
            :minus="calc.minus"
            :unit="calc.unit">
        </calc>
        <standard 
            v-for="standard in standards" 
            :name="standard.name"
            :value="standard.value"
            :minus="standard.minus"
            :unit="standard.unit">
        </standard>
    </div>
  </div>

</template>

<script>
import Hello from '../components/Hello'
import Calc from '../components/Calc'
import Standard from '../components/Standard'

export default {
  name: 'versus',
  components: {
    Hello,
    Calc,
    Standard
  },
  data () {
    return {
      loading: true,
      loadError: false,
      result: false,
      result_msg: ' ',
      heads: {},
      calcs: [],
      standards: [],
      apiUrl: '/q_niu_api/mobile_web/measurements/versus/'
    }
  },
  watch: {
    '$route': function () {
      this.getMeasure()
    }
  },
   // 获取数据
  created: function () {
    this.getMeasure()
  },
  methods: {
    getMeasure: function () {
      this.$http.get(this.apiUrl + this.$route.params.code).then(function (response) {
        // 赋值给数组
        // console.log(response)
        // response.AddHeader('Content-Type', 'text/json')
        this.loading = false
        this.loadError = false

        if (response.body.status_code === '20000') {
          this.result = true
          this.heads = response.body.heads
          this.calcs = response.body.calcs
          this.standards = response.body.standards
        } else {
          this.result = false
          this.result_msg = response.body.message
        }
      }, function (response) {
        // 响应错误回调
        this.loading = false
        this.loadError = true
      })
    }
  }
}
</script>

<style>
#app {
  font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  margin-top: 10px; 
}

 .hello {
  background-color: #FFFFFF; padding: 20px;
  border-radius:15px;
  color: #333333;
   margin-top: 10px;
   margin-left: 8px;
   margin-right: 8px;
   margin-bottom: 10px;
   padding: 12px;
}

.font_name{
  color: #999999;
  font-size: 18px;
}

.font_value{
  color: #727272;
  font-size: 22px;
}

.font_value_s{
  color: #727272;
  font-size: 18px;
}

.font_minus{
  font-size: 24px;
}

.font_unit{
  font-size: 18px;
}

.font_unit_s{
  color: #727272;
  font-size: 16px;
}
 
.font_green{
  color: #45C335;
}

.font_red{
  color: #EA6456;
}

.accow_green{
   width:40px; 
   height: 16px;
   background-image: url('~assets/images/accow_green.png');
   background-position: center;
   background-size:22px 16px;
   background-repeat: no-repeat; 
}

.accow_red{
   width:40px; 
   height: 16px;
   background-image: url('~assets/images/accow_red.png');
   background-position: center;
   background-size:22px 16px;
   background-repeat: no-repeat; 
}

.accow_gray{
   width:40px; 
   height: 16px;
   background-image: url('~assets/images/accow_gray.png');
   background-position: center;
   background-size:22px 16px;
   background-repeat: no-repeat; 
}

.calc_name{
  float: left;
  display:inline;
}

.calc_accow{
  width: 46px;
  height: 30px;
  background-repeat: no-repeat;
  background-image:  url('~assets/images/down_s.png');
  background-size:30px 30px;
  background-position: center;
  float: right;
  display:inline;
}

.calc_accow_red{
  width: 46px;
  height: 30px;
  background-repeat: no-repeat;
  background-image:  url('~assets/images/up_s.png');
  background-size:30px 30px;
  background-position: center;
  float: right;
  display:inline;
}

.minus_value{
  float: left;
  display:inline; 
} 
</style>



// WEBPACK FOOTER //
// versus.vue?508c118b